import { reports } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository();

export default {
  async getReportsList() {
    const r = await client.get(reports.list);
    return r;
  },
  async listRidersAndDrivers() {
    const r = await client.get(reports.listRidersAndDrivers);
    return r;
  },
  async getRoutes(campusId) {
    const r = await client.get(reports.routes, { campusId });
    return r;
  },
  async getReportByType(url, payload = null) {
    const reportUrl = reports.getReportByType.replace(':reportType', url);
    let response = null;
    if (payload) {
      response = await client.get(reportUrl, payload);
    } else {
      response = await client.get(reportUrl);
    }
    return response;
  },
};
